import { lazy, Suspense, type ReactNode } from 'react';
import type { RouteObject } from 'react-router';
import { PageSkeleton } from '../../components/Page';

const StockOverviewPage = lazy(() => import('./pages/StockOverviewPage'));
const PurchasesPage = lazy(() => import('./pages/PurchasesPage'));
const PurchaseEditorPage = lazy(() => import('./pages/PurchaseEditorPage'));
const NfeImportPage = lazy(() => import('./pages/NfeImportPage'));
const SuppliersPage = lazy(() => import('./pages/SuppliersPage'));
const InventoryListPage = lazy(() => import('./pages/InventoryListPage'));
const InventoryCountPage = lazy(() => import('./pages/InventoryCountPage'));

const list = (el: ReactNode) => <Suspense fallback={<PageSkeleton />}>{el}</Suspense>;
const board = (el: ReactNode) => <Suspense fallback={<PageSkeleton variant="dashboard" />}>{el}</Suspense>;

/** Rotas desta área (dentro do shell autenticado). Os caminhos são os do menu (app/nav.ts). */
export const routes: RouteObject[] = [
  { path: 'estoque', element: board(<StockOverviewPage />) },
  { path: 'estoque/compras', element: list(<PurchasesPage />) },
  { path: 'estoque/compras/nova', element: board(<PurchaseEditorPage />) },
  { path: 'estoque/compras/importar', element: list(<NfeImportPage />) },
  { path: 'estoque/compras/:id', element: board(<PurchaseEditorPage />) },
  { path: 'estoque/fornecedores', element: list(<SuppliersPage />) },
  { path: 'estoque/inventarios', element: list(<InventoryListPage />) },
  { path: 'estoque/inventarios/:id', element: list(<InventoryCountPage />) },
];

/** Rotas protegidas sem o shell (ex.: impressão). */
export const fullscreenRoutes: RouteObject[] = [];
